import React, { useState, useEffect } from "react";
import "./huntGraph.scss";
import LineChart from "../../../reusableComponents/graph/lineGraph";
import BarChart from "../../../reusableComponents/graph/barGraph";
import { connect } from 'react-redux'

function GridComponent(props) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? props?.GraphData?.length - 1 : prevIndex - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === props?.GraphData?.length - 1 ? 0 : prevIndex + 1));
  };

  return (


    <div className="graph-container-grid">
      {props.header == 'Bar Graph' &&
        props?.GraphData.map((item) => {
          return (
            <div className="each-graph-container">
              <p className="text-p-graph">{item.variableName}</p>
              <BarChart
                rawData={item}
              // rawData={props?.GraphData[currentIndex]}
              ></BarChart>
            </div>
          )
        }
        )
      }

      {props.header == 'Line Graph' &&
        props?.GraphData.map((item) => {
          return (
            <div className="each-graph-container">
              <p className="text-p-graph">{item.variableName}</p>
              <LineChart
                rawData={item}
                DrawPoints={props.huntplannerMorefilters.DrawPoints}
              // rawData={props?.GraphData[currentIndex]}
              ></LineChart>
            </div>)
        }
        )
      }
    </div>
  );
}


const mapStateToProps = state => ({
  huntplannerMorefilters: state.huntplannerMorefilters
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(GridComponent)
